import React from 'react';
import useOffcanvasStore from 'store/offcanvasStore';
import DynamicOffcanvas from './DynamicOffcanvas';
import { toggleOffCanvas } from 'utils';

const OffcanvasProvider = ({ children }) => {
  const { formType, formProps, isOpen, closeOffcanvas } = useOffcanvasStore();

  React.useEffect(() => {
    if (isOpen) {
      toggleOffCanvas('dynamicOffcanvas');
    }
  }, [isOpen]);

  return (
    <>
      {children}
      {formType && (
        <DynamicOffcanvas
          formType={formType}
          onHide={closeOffcanvas}
          {...formProps}
        />
      )}
    </>
  );
};

export default OffcanvasProvider; 